import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonComponent {
    @Input()
    label: string;
    @Input()
    icon: string;
    @Input()
    iconRight: string;
    @Input()
    loading: boolean;
    @Input()
    disabled: boolean;
    @Input()
    type: string = 'button';
    @Input()
    cssClass: string;
    @Output()
    buttonClick = new EventEmitter();

    public onClick($event: MouseEvent): void {
        if (!this.loading) {
            this.buttonClick.emit($event);
        }
    }

    get canClick(): boolean {
        return !this.disabled && !this.loading;
    }
}
